/**
 * @fileoverview DELETE handler for the "/:app_group_id/canvas_brief/:canvas_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { canvasBriefCacheKeys } from "./constants";
import type { DeleteCanvasBriefProps, DeleteCanvasBriefResult } from "./types";

export const deleteCanvasBrief = reactQueryMutationAdapter(
  canvasBriefCacheKeys,
  (props: DeleteCanvasBriefProps): Promise<DeleteCanvasBriefResult> => {
    return fetch(`/${props.appGroupId}/canvas_brief/${props.canvasId}`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
